import { readJsonPref, writeJsonPref } from "./prefs";

export interface TagDef {
	id: string;
	label: string;
}

export const DEFAULT_TAGS: TagDef[] = [
	{ id: "remember", label: "기억할 장면" },
	{ id: "again", label: "다시 가고 싶은 곳" },
	{ id: "routine", label: "나의 루틴" },
];

const TAGS_KEY = "sobidogam:tags";

function isTagList(value: unknown): value is TagDef[] {
	return (
		Array.isArray(value) &&
		value.every(
			(tag) =>
				tag &&
				typeof tag === "object" &&
				typeof (tag as TagDef).id === "string" &&
				typeof (tag as TagDef).label === "string",
		)
	);
}

/** Tags cut across categories ("제주 여행", "경조사"). Kept on this device. */
export function readTags(): TagDef[] {
	const stored = readJsonPref<unknown>(TAGS_KEY, null);
	return isTagList(stored) ? stored : DEFAULT_TAGS;
}

export function writeTags(tags: TagDef[]): boolean {
	return writeJsonPref(TAGS_KEY, tags);
}

export function normalizeTagLabel(label: string): string {
	return label.normalize("NFKC").trim().replace(/\s+/g, " ").slice(0, 20);
}

export function tagLabel(tags: TagDef[], id: string): string {
	return tags.find((tag) => tag.id === id)?.label ?? "지운 태그";
}
